import React from 'react'
import styled from 'styled-components'

const HalfDiv = styled.div`
    width:50%;
    margin:auto;
    @media only screen and (max-width:600px){
        width:100%;
    }
  `

export default props =><HalfDiv>{props.children}</HalfDiv>